export const emojiOptions = {
  prayerHands: '🙏',
  globe: '🌎',
  heart: '❤️',
} as const;

export const getEmojiOption = (emoji: string) => {
  return emojiOptions[emoji as keyof typeof emojiOptions];
};
